<template>
<div class="border-outside">
    <div class="">
        <h1 class="font-title">過去月の全スタッフ請求書のダウンロード </h1>
        <div class="desc-flex">
            <span class="font-desc">請求書のダウンロード</span>
            <input min="2023-05" :max="currenYearMonth" v-model="dateMonth" type="month" class="date-input" lang="ja-JP" />
            <button @click="getFileFetch" class="select-button">
                進める
            </button>
        </div>
    </div>
    <div :key="index" v-for="(fileEvent, index) in fileEventStream">
        <div v-if="fileEvent.progress !== 100">
            <div class="loading-flex">
                <div class="loading-title">
                    <span>お待ちください...</span>
                    <span class="progress-text">{{ fileEvent.progress }}%</span>
                </div>
                <progress :value="fileEvent.progress" max="100" />
            </div>
        </div>
        <div v-else>
            <div class="donwload-flex">
                <div class="donwload-desc">
                    <div class="donwload-name-title">{{ fileEvent.name }}
                        <span class="donwload-size-title">{{ getDecodedSize(fileEvent.zipBytes) }} Mb</span>
                    </div>
                    <span @click="onClickDonwload(fileEvent.zipBytes, fileEvent.name)" class="donwload-href">ダウンロード</span>
                </div>
                <div class="circle-grey">
                    <img src="../assets/file.png" />
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script lang="ts">
import {defineComponent, ref} from "vue";
import {backendApi} from "@/utils/backend-api";
import { authStore } from "@/stores/auth-store";

export default defineComponent({
    name: "DonwloadInvoiceMontly",
    setup() {

        type StreamData = {
            zipBytes: string,
            progress: number,
            isDone: boolean,
            name: string,
        }
        
        const now = new Date();
        const currenYearMonth = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;

        const isDoneClass = (progressData: StreamData) => {
            if(progressData.progress === 100) {
                return true
            } else {
                return false
            }
        }

        const dateMonth = ref<Date>(),
            fileEventStream = ref<StreamData[]>([] as StreamData[]),
            currentIdStream = ref<number>(0)

        function getDecodedSize(base64String: string) {
            const base64 = base64String.replace(/\s/g, '');
            const padding = (base64.match(/=*$/) || [''])[0].length;
            const sizeInBytes = (base64.length * 3 / 4) - padding;
            const sizeInMB = sizeInBytes / (1024 * 1024);
            const sizeDecimal = parseFloat(sizeInMB.toFixed(2))
            return sizeDecimal;
        }

        function base64ToZipBlob(base64String: string) {
            const [header, base64] = base64String.split(',');
            const mimeMatch = header.match(/data:(.*);base64/);
            const mimeType = mimeMatch ? mimeMatch[1] : 'application/zip';

            const binary = atob(base64);
            const len = binary.length;
            const bytes = new Uint8Array(len);

            for (let i = 0; i < len; i++) {
                bytes[i] = binary.charCodeAt(i);
            }

            return new Blob([bytes], { type: mimeType });
        }

        function downloadBlob(blob: Blob, fileName: string) {
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            a.click();
            URL.revokeObjectURL(url);
        }

        const onClickDonwload = (fileData: string, fileName: string) => {
            const fullBase64 = "data:application/zip;base64," + fileData;
            const zipBlob = base64ToZipBlob(fullBase64);
            downloadBlob(zipBlob, fileName);
        }

        const getFileFetch =  async() => {
            const stringMonth = dateMonth.value?.toString()
            const year = stringMonth?.split("-")[0]
            const month = stringMonth?.split("-")[1]
            const reqBody = {
                year, 
                month
            }
            const token = authStore.state.token
            const stop = await backendApi.connectEventStream<any>(
                (data, numberId) => {
                    if(!fileEventStream.value[numberId]) {
                        fileEventStream.value.push({} as StreamData)
                    }
                    if(data.file_name) {
                        fileEventStream.value[numberId].name = data.file_name
                    }
                    if(data.progress) {
                        fileEventStream.value[numberId].progress = data.progress
                    }
                    if(data.zip_bytes) {
                        fileEventStream.value[numberId].zipBytes = data.zip_bytes
                    }
                    if(data.step === "Finishing") {
                        stop()
                    }
                },
                currentIdStream.value,
                (err) => {
                    console.error("Stream error:", err);
                },
                {
                    method: "POST",
                    token: token,
                    body: reqBody,
                },
            );
            currentIdStream.value += 1
        } 

        return {
            dateMonth,
            getFileFetch,
            fileEventStream,
            isDoneClass,
            onClickDonwload,
            getDecodedSize,
            currenYearMonth,
        }
    }
})
</script>

<style scoped lang="scss">
.border-outside {
    border: 2px solid lightgray;
    border-radius: 5px;
    display: flex;
    width: 100%;
    flex-direction: column;
}
.font-title {
    font-weight: 700;
    font-size: 32px;
    margin-bottom: 12px;
    margin-top: 20px;
}
.desc-flex {
    display: flex;
    gap: 12px;
    align-items: center;
    padding: 12px;
    margin-left: 20px;
}
.font-desc {
    font-weight: 400;
    font-size: 20px;
}
.select-button {
    background-color: #838383;
    color: white;
    border-radius: 8px;
    padding: 10px;
    border: none;
    width: 178px;
}
.date-input {
    height: 41px;
    width: 178px;
    background-color: #EBEBEB;
    padding: 10px 12px;
    border-radius: 8px;
    border: none;
}
.loading-flex {
    display: flex;
    flex-direction: column;
    justify-content: left;
    padding: 16px;
    margin: 12px 20px;
    border: 1px solid #9F9F9F;
    border-radius: 8px;
    gap: 8px;
}
.loading-title {
    display: flex;
    font-size: 20px;
    font-weight: 400;
    gap: 27px;
    align-items: center;

    .progress-text {
        font-size: 24px;
        font-weight: 700;
        color: #FF8C00;
    }
}

.donwload-desc {
    display: flex; 
    flex-direction: column;
    gap: 8px;
    font-size: 20px;

    .donwload-size-title {
        color: #9F9F9F;
    }

    .donwload-href {
        color: #294199;
        text-decoration: underline;
        font-weight: 600;
        text-align: left;
    }
}

progress {
    border-radius: 7px;
    height: 8px;
    width: 100%;
}
progress::-webkit-progress-bar {
    background-color: #CBCBCB;
    border-radius: 8px;
}
progress::-webkit-progress-value {
    background-color: #FF8C00;
    border-radius: 8px;
}

.donwload-flex {
    display: flex;
    padding: 16px;
    margin: 12px 20px;
    border: 1px solid #9F9F9F;
    border-radius: 8px;
    justify-content: space-between;
    align-items: center;
}

.circle-grey {
    width: 50px;
    height: 50px;
    background-color: #F1F1F1;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>